import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import Image from 'UIKit/Image'
import Text from 'UIKit/Text'
import { UserBonus } from 'config/types/bonus/userBonus'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Icons } from 'svgs'
import colors from 'theme/ui/colors'
import { buildBonusName } from '../hooks'
import { useUpcomingBonusModal } from './UpComingBonusModal/hook'

interface UpcomingBonusProps {
  bonus: UserBonus
}

const UpcomingBonus: React.FC<UpcomingBonusProps & BoxProps> = ({ bonus, ...props }) => {
  const { t } = useTranslation()
  const { presentUpcomingBonusesModal } = useUpcomingBonusModal()

  return (
    <Box
      {...props}
      position="relative"
      onClick={async (e) => {
        e.stopPropagation()
        e.preventDefault()
        await presentUpcomingBonusesModal(bonus)
      }}
    >
      <Box width="100%" height="1px" background={colors.strokeBlur} mb="8px" />
      <Text fontWeight={500} fontSize="10px" letterSpacing={-0.16} color="textAlt1" mb="4px">
        <Trans>Upcoming Bonus</Trans>
      </Text>
      <UpcomingBonusContainer mb="12px">
        <Flex alignItems="center" justifyContent="space-between">
          <Flex>
            <StyledImage mr="4px">
              <Image src={bonus.bonusUpcoming[0].info.image} alt="gift-header-title" width={24} height={24} />
            </StyledImage>
            <Flex alignItems="center">
              <Text fontSize="12px" color="textSubtle" fontWeight={500} letterSpacing={-0.24} lineHeight="normal">
                {buildBonusName(t, bonus.bonusUpcoming[0].info?.name)[0]}
              </Text>
            </Flex>
          </Flex>

          <StyledInfoIcon />
        </Flex>
      </UpcomingBonusContainer>
    </Box>
  )
}

const UpcomingBonusContainer = styled(Box)`
  background: ${({ theme: { colors } }) => colors.backgroundAlt5};
  border-radius: 4px;
  padding: 4px 10px;

  &:last-child {
    margin-bottom: unset;
  }
`

const StyledInfoIcon = styled(Icons.WarningIconCircle)`
  transform: scale(0.75);
  width: 24px;
  height: 24px;
  fill: ${({ theme: { colors } }) => colors.textAlt1};
  path {
    fill: ${({ theme: { colors } }) => colors.textAlt1};
  }
`

const StyledImage = styled(Box)`
  img {
    min-width: 24px;
    min-height: 24px;
  }
`
export default UpcomingBonus
